export const GET_DEAL_SCREEN = 'dealScreen/GET_DEAL_SCREEN'
export const START_LOADING_DEAL_SCREEN = 'dealScreen/START_LOADING_DEAL_SCREEN'
export const STOP_LOADING_DEAL_SCREEN = 'dealScreen/STOP_LOADING_DEAL_SCREEN'
export const SET_DEAL_SCREEN_STATUSES = 'dealScreen/SET_DEAL_SCREEN_STATUSES'
export const INVALIDATE_DEAL_SCREEN = 'dealScreen/INVALIDATE_DEAL_SCREEN'
export const DEAL_SCREEN_LOAD_FAILED = 'dealScreen/DEAL_SCREEN_LOAD_FAILED'
